import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setIsFullScreen } from "../../redux/slices/controllerSlice";
import { handleIsComplexDesktop } from "../helpers";
import { conditions } from "../conditions/conditions";
import { ConditionName } from "../../interfaces/enums";
import { setIsComplexDesktop, setIsComplexPortrait } from "../../redux/slices/videoDataSlice";
import { fullscreenLog } from "../../logs/logs";
import { sendFluentLog } from "../../logs/fluentdLogger";
import { handleVideoElementSizeInfo } from "../../redux/actions/controller.actions";
import { shallowEqual } from "react-redux";

const useFullScreen = () => {
    const dispatch = useAppDispatch();
    useAppSelector(({ videoData: { params } }) => ({ params }), shallowEqual);

    useEffect(() => {
        const handleChangeFullScreen = () => {
            const isFullScreen = document.fullscreenElement;

            if (isFullScreen) dispatch(setIsFullScreen(true));
            else {
                dispatch(setIsFullScreen(false));
                handleVideoElementSizeInfo();
                sendFluentLog(fullscreenLog("exitFullScreen"));
                if (conditions(ConditionName.isTouchScreen) && conditions(ConditionName.isParamsPortrait)) dispatch(setIsComplexPortrait(true));
            }
            if (handleIsComplexDesktop(conditions(ConditionName.isParamsPortrait)) && !conditions(ConditionName.isStaticFormat))
                dispatch(setIsComplexDesktop(true));
        };

        if (document.addEventListener) {
            document.addEventListener("webkitfullscreenchange", handleChangeFullScreen, false);
            document.addEventListener("mozfullscreenchange", handleChangeFullScreen, false);
            document.addEventListener("fullscreenchange", handleChangeFullScreen, false);
            document.addEventListener("MSFullscreenChange", handleChangeFullScreen, false);
        }

        () => {
            document.removeEventListener("webkitfullscreenchange", handleChangeFullScreen, false);
            document.removeEventListener("mozfullscreenchange", handleChangeFullScreen, false);
            document.removeEventListener("fullscreenchange", handleChangeFullScreen, false);
            document.removeEventListener("MSFullscreenChange", handleChangeFullScreen, false);
        };
    }, []);
};

export default useFullScreen;
